import React, { useState } from "react";
import { PRICING_MEMBER_PRICE_SUMMARY } from "../constants/pricing.js";
import { startCheckout } from "../utils/startCheckout.js";

const SubscribeButton = ({ verifiedEmail, isSubscriber }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  if (isSubscriber || !verifiedEmail) {
    return null;
  }

  const handleSubscribe = async () => {
    setIsLoading(true);
    setError("");
    try {
      await startCheckout(verifiedEmail);
    } catch (err) {
      console.error(err);
      setError("Unable to start checkout right now.");
      setIsLoading(false);
    }
  };

  return (
    <div className="subscribe-banner">
      <div className="subscribe-banner__content">
        <p className="subscribe-banner__text">
          Unlock unlimited insights for {PRICING_MEMBER_PRICE_SUMMARY}
        </p>
        <button
          className="primary-button subscribe-banner__button"
          type="button"
          onClick={handleSubscribe}
          disabled={isLoading}
        >
          {isLoading ? "Loading…" : "Subscribe"}
        </button>
        {error ? <p className="subscribe-banner__error">{error}</p> : null}
      </div>
    </div>
  );
};

export default SubscribeButton;
